import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router'
import { OrderService } from '@se-po/se-my-sportsengine-data-access'
import { Observable, of } from 'rxjs'
import { Sale } from '../models'

export const OrderResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: OrderService = inject(OrderService)
): Observable<Sale> => {
  const orderId = route.params.orderId
  return orderId ? service.find(orderId) : of(null)
}
